import { React, useEffect, useState,  } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import Header from './HeaderMob';
import BuyProcessMob from './buyProcessMob';

function BuyMobile(props) {

    const { idea } = useParams();
    const navigate = useNavigate();
    const [phrase, setPhrase] = useState("");
    const [done, setDone] = useState(false);
    const [forSale, setForSale] = useState(true);
    const [level, setLevel] = useState(0);
    const [Owner, setOwner] = useState(false);
   
    const getSingle = process.env.REACT_APP_SINGLE_REQUEST_END_POINT;
    function turnToPhrase(str) {
        return str.replace(/_/g, " ").replace(/\|/g, " ");
    }

    async function getData(idea) {
        var user = sessionStorage.getItem("userinfo");
        //n está logado
        if (!user) { 
            console.log('user not logged');
            //return
        }
      
        const h = {
        "Content-Type": "application/json",
        };

        var options = {
        method: "GET",
        headers: h,
        };


        await fetch(getSingle + idea, options)
            .then(response => response.json())
            .then(function (data) {
                if (data.ForSale === 0) setForSale(false);
        if (
          sessionStorage.getItem("buyInfo") !== null &&
          JSON.parse(sessionStorage.getItem("buyInfo")).sellerUserId ==
            JSON.parse(sessionStorage.getItem("userinfo"))?.id
        )
          setOwner(true);

        setPhrase(turnToPhrase(data.phrase));
        sessionStorage.setItem(
          "buyInfo",
          JSON.stringify({
            phraseData: data,
            BuyerUserId:
              JSON.parse(sessionStorage.getItem("userinfo")) === null
                ? 0
                : JSON.parse(sessionStorage.getItem("userinfo"))?.id, // userId that buys
            sellerUserId: data.user.id, // userId that sells
            phraseId: data.id, //phrase
            wallet: sessionStorage.getItem("wallet"), //wallet
            forsale: false, //boolen with the intention
            price: data.value, //integer with the new price
          })
        );
      });
    }
    

    useEffect(() => { 
        async function fetchData() {
            if (!idea) {
                navigate("/");
            } else { 
                if (phrase === "") { 
                    await getData(idea);
                    setDone(true);
                }
                
            }
        }
        fetchData();
    });
    
    function close() {
        navigate('/' + idea)
    }
    
    return (
        <div className='w-full h-dvh border-0 border-red-600'>
          
            <Header destination="/" from="about" />
            {/* first level of buy */}
            {level == 0 ? 
                <>
                    {Owner ?
                <div>
                 <div className='w-full h-dvh text-black flex items-center justify-center text-center p-4 border-red-700'>
                       Sorry, you already own this idea
                 </div>
            </div>
                :
                        
                        !forSale ? 
            <>
            <div className='w-full h-dvh text-black flex items-center justify-center text-center p-4 border-red-700'>
                Sorry, this idea is not for sale
            </div>
            </>
                    :
                    
            <>                
            <div className='phrase items-center w-dvw border-0 h-dvh text-justify p-0 text-sm flex justify-center content-center '>
                <div className='absolute top-1/4 p-10 border-0'>    
                            {phrase}
                          
                </div>
                
            </div>
            <div className={"mouse2 absolute top-3/4 w-screen flex justify-center" } onClick={(e) => (setLevel(level+1))} >Buy</div>
            </>
            }
            </>
                :
                null
            }
            {level == 1 ?
                <>
                    {done ?

                <BuyProcessMob idea={idea} stage={1} />
                    :
                <div> [ Please Wait ] </div>
                }
                </>
                :
                null
            }
               
            
            </div>
    )



}

export default BuyMobile

